import React from 'react';
import NotificationComponent from './NotificationComponent.jsx';
const Home = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-6">
                Welcome to the Improvement of security and transparency in data exchange procedures applying blockchain and identity based encryption technologies
            </h1>

            <NotificationComponent />

            <div className="mt-8 text-center">
                <p className="text-xl text-gray-600">
                    Here, you can monitor real-time logistics data, manage shipments, and much more!
                </p>
            </div>
        </div>
    );
};

export default Home;
